// extracted by mini-css-extract-plugin
export default {"root":"NavFooter_root__zHljw","backBtn":"NavFooter_backBtn__DbZ+Z","nextBtn":"NavFooter_nextBtn__4ErKm","nextBtnDisabled":"NavFooter_nextBtnDisabled__oGtPz"};